import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, forwardRef } from '@angular/core';
import { AbstractFilterOption, AndFilterOption, OrFilterOption } from '@elio/emanager-front/shared/models';
import { findFilterValue } from '@elio/emanager-front/shared/utils';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { rotate, vSlideInOut } from '@elio/shared/utils';
import { TranslocoModule } from '@ngneat/transloco';
import { LetDirective } from '@ngrx/component';
import { map } from 'rxjs';
import { FILTERABLE_STORE, FilterableStore, FilterableType } from '../../filter.token';
import { ElioFilterItemComponent } from '../filter-item/filter-item.component';

@Component({
  selector: 'elio-filter-accordion[filter]',
  templateUrl: './filter-accordion.component.html',
  standalone: true,
  imports: [CommonModule, forwardRef(() => ElioFilterItemComponent), ElioSvgIconsModule, LetDirective, TranslocoModule],
  animations: [rotate(180, 0, 500), vSlideInOut()],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElioFilterAccordionComponent<T extends FilterableType> implements OnInit {
  @Input() filter!: OrFilterOption<T> | AndFilterOption<T>;

  readonly isSelected$ = this.filterableStore.activeFiltersIds$.pipe(
    map((activeFilterIds) => {
      const found = findFilterValue(this.filter, (fv) => activeFilterIds.includes(fv.id));
      return !!found;
    })
  );

  isExpanded = false;

  constructor(@Inject(FILTERABLE_STORE) private filterableStore: FilterableStore<T>) {}

  ngOnInit(): void {
    this.isExpanded = this.filter.isExtendedByDefault;
  }

  toogleIsExpanded() {
    this.isExpanded = !this.isExpanded;
  }

  trackById(_index: number, item: AbstractFilterOption<T>) {
    return item.id;
  }
}
